// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kI-z","hovered":"lI-z","hoverImage":"mI-z","mainImage":"nI-z","imageNoBackground":"oI-z","fullSizeImage":"pI-z"};